export default "__VITE_ASSET__BsoEvyNQ__"